/**
 * Purpose Table Component
 *
 * Displays paginated list of purposes using Equal DS table.
 */

import React, { useMemo } from 'react';
import { Table, type TableColumn } from 'equal-ds-ui';
import type { PurposeTableProps, PurposeRecord } from '../../../types/purpose';

export const PurposeTable: React.FC<PurposeTableProps> = ({
  data,
  currentPage,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
  isLoading,
}) => {
  const columns = useMemo<TableColumn<PurposeRecord>[]>(() => [
    {
      key: 'category_type',
      header: 'Category Type',
      width: 220,
      render: (_value, row) => <span className="text-sm">{row.category_type}</span>,
    },
    {
      key: 'purpose_code',
      header: 'Purpose Code',
      width: 160,
      render: (_value, row) => (
        <span className="text-sm font-mono">{row.purpose_code}</span>
      ),
    },
    {
      key: 'refuri',
      header: 'Reference URI',
      width: 320,
      render: (_value, row) => (
        <span className="text-sm break-words">{row.refuri || '--'}</span>
      ),
    },
    {
      key: 'purpose_text',
      header: 'Description',
      width: 360,
      render: (_value, row) => (
        <span className="text-sm break-words">{row.purpose_text}</span>
      ),
    },
    {
      key: 'createdAt',
      header: 'Created On',
      width: 200,
      render: (_value, row) => <span className="text-sm">{row.createdAt}</span>,
    },
  ], []);

  return (
    <div className="flex-1 min-h-0 flex flex-col p-4 border border-border-default rounded-xl shadow-sm bg-white">
      <Table
        className="flex-1 min-h-0"
        data={data}
        columns={columns}
        loading={isLoading}
        pagination={{
          currentPage,
          pageSize,
          totalItems,
          onPageChange,
          onPageSizeChange,
          pageSizeOptions: [50, 100, 500, 1000],
        }}
        columnManager={{
          enabled: true,
          allowHiding: false,
        }}
      />
    </div>
  );
};
